import React from 'react';

interface ErrorComponentProps {
  msg?: string;
}

export const ErrorComponent: React.FC<ErrorComponentProps> = ({ msg }) => {
  return (
    <div style={{ margin: '2rem auto', maxWidth: 600, textAlign: 'center' }}>
      <p style={{ marginBottom: '1.5rem' }}>
        {msg ||
          'An error occurred during app initialization, please try again or after some time.'}
      </p>
      <p>
        <a
          href="https://iweof.sharepoint.com/:u:/r/teams/o365g_fmsreporting_itnl012/SitePages/Home.aspx?csf=1&web=1&e=ljcPFP"
          target="_blank"
          rel="noopener noreferrer"
        >
          Help
        </a>
      </p>
    </div>
  );
};
